__turbopack_context__.v({
  "arrow": "AdminLocaleSwitch-module__UdLorq__arrow",
  "code": "AdminLocaleSwitch-module__UdLorq__code",
  "icon": "AdminLocaleSwitch-module__UdLorq__icon",
  "label": "AdminLocaleSwitch-module__UdLorq__label",
  "menu": "AdminLocaleSwitch-module__UdLorq__menu",
  "menuCheck": "AdminLocaleSwitch-module__UdLorq__menuCheck",
  "menuCode": "AdminLocaleSwitch-module__UdLorq__menuCode",
  "menuFooter": "AdminLocaleSwitch-module__UdLorq__menuFooter",
  "menuHeader": "AdminLocaleSwitch-module__UdLorq__menuHeader",
  "menuItem": "AdminLocaleSwitch-module__UdLorq__menuItem",
  "menuItemActive": "AdminLocaleSwitch-module__UdLorq__menuItemActive",
  "menuLabel": "AdminLocaleSwitch-module__UdLorq__menuLabel",
  "trigger": "AdminLocaleSwitch-module__UdLorq__trigger",
  "triggerOpen": "AdminLocaleSwitch-module__UdLorq__triggerOpen",
  "wrapper": "AdminLocaleSwitch-module__UdLorq__wrapper",
});
